import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination, showConfirm } from '@/components/xqxc_ui';
import { Table, Typography, Switch } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip } from '@/components/TableCell';
import moment from 'moment';

const TableContent = ({
    renderData: {
        dataList,
        pageNum,
        pageSize,
        resultTotal
    },
    request,
    paginationChange
}) => {

    const switchCell = (text, { operationAreaInfoId }) => {
        return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
            <Switch
                checkedChildren='上线'
                unCheckedChildren='下线'
                checked={text === 'ENABLE' ? true : false}
                onChange={value => {
                    if (value) {
                        request(
                            '/?cmd=com.xqxc.api.pig.mis.biz.user.company.OperationAreaInfoMisService.updateOperationAreaInfoStatus',
                            { operationAreaInfoId, status: 'ENABLE' },
                            '上线操作成功'
                        );
                    } else {
                        showConfirm('当前区县已上线运营，下线后将不再推送订单给该区域骑士，您确认要下线么？', '', () => {
                            request(
                                '/?cmd=com.xqxc.api.pig.mis.biz.user.company.OperationAreaInfoMisService.updateOperationAreaInfoStatus',
                                { operationAreaInfoId, status: 'DISABLE' },
                                '下线操作成功'
                            );
                        });
                    }
                }}
            />
        </div>;
    };

    const tableOperate = (text, item) => {
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => {
                    showConfirm('城市回收后不在显示',
                        <Typography.Text type='danger'>运营公司不可以运营该区域，你还要回收吗？</Typography.Text>,
                        () => request('/?cmd=com.xqxc.api.pig.mis.biz.user.company.OperationAreaInfoMisService.recoverOperationAreaInfo', {}, '回收操作成功'));
                }}>回收</div>
            </div>
        );
    };


    const columns = [
        {
            title: '省份',
            dataIndex: 'provinceName',
            key: 'provinceName',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '区县',
            dataIndex: 'areaName',
            key: 'areaName',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '运营公司',
            dataIndex: 'companyName',
            key: 'companyName',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '骑士数量',
            dataIndex: 'countRider',
            key: 'countRider',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: '12%',
            align: 'center',
            onCell: tooltipStyle,
            render: switchCell
        },
        {
            title: '上线时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: text => text ? tooltip(moment(text).format('YYYY-MM-DD HH:mm:ss')) : ''
        },
        // {
        //     title: '操作',
        //     dataIndex: 'operationAreaInfoId',
        //     key: 'operationAreaInfoId',
        //     align: 'center',
        //     width: '12%',
        //     onCell: tooltipStyle,
        //     render: tableOperate
        // },
    ];

    return <div className={styles.tableContainer}>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={(r, i) => i}
            columns={columns}
            dataSource={dataList}
            pagination={false}
            scroll={{ y: true }}
        />
        <XPagination
            resultTotal={resultTotal}
            pageSize={pageSize}
            pageNum={pageNum}
            onChange={paginationChange}
        />
    </div>;
};

TableContent.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    request: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableContent;

